import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import {
  AtsEntitiesInsightsDataSourceIdEnum,
  AtsLastUpdatedAtInsightFragment,
} from 'generated/resources/graphql'
import capitalize from 'lodash/capitalize'

import i18n from 'modules/core/lib/i18n'

import { timeAgoWhenRecent } from 'modules/ats/lib/dates'

interface Props {
  lastUpdatedAts?: AtsLastUpdatedAtInsightFragment[]
  id: AtsEntitiesInsightsDataSourceIdEnum
}

export const LastUpdatedAt = ({ lastUpdatedAts, id }: Props) => {
  if (!lastUpdatedAts) return null

  const lastUpdatedAt = lastUpdatedAts.find((updatedAt) => updatedAt.id === id)
  if (!lastUpdatedAt) return null

  return (
    <Box flexDirection="row" alignItems="center" gap="s6" flexNoShrink>
      <Icon.Medium icon="clock" color="grey1000" />
      <Text.Normal size="200" color="grey1000">
        {i18n.t('ats.insights_page.last_updated', {
          timeAgo: capitalize(timeAgoWhenRecent(lastUpdatedAt.date)),
        })}
      </Text.Normal>
    </Box>
  )
}
